import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Entitlement_Activate = () => {
  const [entMonth, setEntMonth] = useState('');
  const [entYear, setEntYear] = useState('');
  const [selectedDistrictCode, setSelectedDistrictCode] = useState('');
  const [selectedSchemeId, setSelectedSchemeId] = useState('');
  const [selectedCommId, setSelectedCommId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [reportTitle, setReportTitle] = useState('');

  const [masterData, setMasterData] = useState({
    entitlements: [],
    districts: [],
    schemeNames: [],
    commNames: []
  });

  const [summaryData, setSummaryData] = useState([]);
  const [showSummary, setShowSummary] = useState(false);
  const [lastSubmittedData, setLastSubmittedData] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}/api/entitlement/master-data`)
      .then(res => setMasterData(res.data))
      .catch(error => {
        console.error('Error fetching master data:', error);
        alert('Error fetching master data.');
      });
  }, []);

  const fetchSummaryRecords = async () => {
    setSummaryData([]);
    setShowSummary(false);

    try {
      const res = await axios.get(`${process.env.REACT_APP_URL}/api/entitlement/summary-records`, {
        params: { month: entMonth, year: entYear }
      });

      if (Array.isArray(res.data)) {
        setSummaryData(res.data);
        setShowSummary(true);
      } else if (res.data.message) {
        alert(res.data.message);
      } else {
        alert('Unexpected error occurred.');
      }
    } catch (error) {
      console.error('Error fetching summary records:', error);
      alert('Error fetching summary records.');
    }
  };

  const handleSubmit = async () => {
    if (!entMonth || !entYear || !selectedDistrictCode || !selectedSchemeId || !selectedCommId) {
      alert('Please fill all fields.');
      return;
    }

    const currentInput = {
      month: parseInt(entMonth),
      year: parseInt(entYear),
      districtCode: selectedDistrictCode || 'ALL',
      schemeId: parseInt(selectedSchemeId || '0'),
      commId: parseInt(selectedCommId || '0')
    };

    if (JSON.stringify(currentInput) === JSON.stringify(lastSubmittedData)) {
      alert('No changes happened, already submitted.');
      return;
    }

    try {
      const monthName = new Date(0, entMonth - 1).toLocaleString('default', { month: 'long' });
      setReportTitle(`Entitlement Status for ${monthName} ${entYear}`);

      setIsLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_URL}/api/entitlement/insert-entitlement`, currentInput);
      setLastSubmittedData(currentInput);
      alert(response.data.message);

      if (response.data.message !== 'Table not found for the selected month and year') {
        await fetchSummaryRecords();
      }
    } catch (error) {
      console.error('Error updating entitlement data:', error);
      alert('Error updating data.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="wrapper row3" style={{ maxHeight: '95vh', overflowY: 'auto', paddingBottom: '40px' }}>
      <div id="container">
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
          <table width="90%">
            <thead>
              <tr className="tableheader">
                <th colSpan={10}>ENTITLEMENT GENERATION</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Ent Month:</td>
                <td>
                  <select value={entMonth} onChange={e => setEntMonth(e.target.value)} required>
                    <option value="">--Select Month--</option>
                    {masterData.entitlements.map((it, i) => (
                      <option key={i} value={it.month}>
                        {new Date(0, it.month - 1).toLocaleString('default', { month: 'long' })}
                      </option>
                    ))}
                  </select>
                </td>

                <td>Ent Year:</td>
                <td>
                  <select value={entYear} onChange={e => setEntYear(e.target.value)} required>
                    <option value="">--Select Year--</option>
                    {masterData.entitlements
                      .filter(it => it.month === parseInt(entMonth))
                      .map((it, i) => (
                        <option key={i} value={it.year}>
                          {it.year}
                        </option>
                      ))}
                  </select>
                </td>

                <td>District:</td>
                <td>
                  <select value={selectedDistrictCode} onChange={e => setSelectedDistrictCode(e.target.value)}>
                    <option value="">--Select District--</option>
                    <option value="ALL">All</option>
                    {masterData.districts.map((d, i) => (
                      <option key={i} value={d.districtCode}>
                        {d.districtName}
                      </option>
                    ))}
                  </select>
                </td>

                <td>Scheme:</td>
                <td>
                  <select value={selectedSchemeId} onChange={e => setSelectedSchemeId(e.target.value)}>
                    <option value="">--Select Scheme--</option>
                    <option value="0">All</option>
                    {masterData.schemeNames.map((s, i) => (
                      <option key={i} value={s.schemeId}>
                        {s.schemeName}
                      </option>
                    ))}
                  </select>
                </td>

                <td>Commodity:</td>
                <td>
                  <select value={selectedCommId} onChange={e => setSelectedCommId(e.target.value)}>
                    <option value="">--Select Commodity--</option>
                    <option value="0">All</option>
                    {masterData.commNames.map((c, i) => (
                      <option key={i} value={c.commId}>
                        {c.commName}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20, marginBottom: 20 }}>
          {!isLoading ? (
            <button type="button" onClick={handleSubmit} className="button button2">
              Submit
            </button>
          ) : (
            <div style={{ marginTop: '10px' }}>
              <img src="https://epos.assam.gov.in/images/progress.gif" alt="Loading..." />
            </div>
          )}
        </div>

        {showSummary && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 20 }}>
            <table width="90%" border="1" style={{ borderCollapse: 'collapse', textAlign: 'center' }}>
              <thead>
                <tr className="tableheader">
                  <th colSpan={6}>{reportTitle}</th>
                </tr>
                <tr style={{ backgroundColor: 'black', color: 'white' }}>
                  <th>Month</th>
                  <th>Year</th>
                  <th>District</th>
                  <th>Scheme</th>
                  <th>Commodity</th>
                  <th>Entitlement Status</th>
                </tr>
              </thead>
              <tbody>
                {summaryData.length > 0 ? (
                  summaryData.map((record, i) => (
                    <tr key={i}>
                      <td>{record.month !== 0 ? new Date(0, record.month - 1).toLocaleString('default', { month: 'long' }) : ''}</td>
                      <td>{record.year || ''}</td>
                      <td>{record.districtName}</td>
                      <td>{record.schemeName}</td>
                      <td>{record.commName}</td>
                      <td style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        {record.entitleDone === 'Present' ? (
                          <span style={{ color: 'green', fontSize: '12px' }}>&#10004;</span>
                        ) : (
                          <span style={{ color: 'red', fontSize: '12px' }}>&#10060;</span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan={6}>Loading or no data found…</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Entitlement_Activate;
